export default "__VITE_ASSET__BAZKHX$2__"